// extracted by mini-css-extract-plugin
export default {"page-login":"login_page-login__VSVC5","login-card":"login_login-card__A6Oox","title":"login_title__6Gxi7","login-form-button":"login_login-form-button__iXvMo"};